const LeftArrow = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.00977 10.9805H17.9998"
      stroke="#9DA6B0"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.01295 4.98828L3.00195 11.0003L9.01295 17.0123"
      stroke="#9DA6B0"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default LeftArrow;
